import React, { useEffect, useRef, useState } from 'react';
import { ContentCard, SettlementModal } from '../Common';
import { Button, Icon, Menu, Dropdown, Alert } from 'antd';
import { connect } from 'react-redux';
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome';
import { faWallet } from '@fortawesome/free-solid-svg-icons/faWallet';
import { alertify, getIndianRupeeNotation, handleApiExceptions } from '../../app_methods';
import VirtualAccountsComponent from './virtual_accounts';
import Disbursements from './disbursements';
import Ledger from './ledger';
import TransactionOrders from './orders'
import VATransactions from './transactions';
import { faRupeeSign } from '@fortawesome/free-solid-svg-icons/faRupeeSign';
import { Route, Switch } from 'react-router-dom'
import { SmartCollectDisbursements } from '../../models';
import { toggleBulkOrderModalAction, toggleCreateOrderModalAction, updateCurrentUserAction, toggleBulkRefundModalAction } from '../../redux/actions';
import { MerchantService } from '../../services';
import { CreatePermissionHoc, PermissionHoc } from '../HOC';


const PermissableButton = PermissionHoc(Button, null, { is_component: true, fallbackComponent: null })

const SmartCollect = (props) => {
    const [currentPage, setCurrentPage] = useState();
    const [loading, setLoading] = useState(false);
    const [settlementAccounts, setSettlementAccounts] = useState([]);
    const [showSettlementModal, setShowSettlementModal] = useState(false);
    const actionRef = useRef(null);
    const bulkButtonRef = useRef(null);
    const virtual_account_settings = props.current_user?.smart_collect_virtual_account_settings ?? {}; //not showing, need to refresh 
    
    const OrderPermissableButton = CreatePermissionHoc({ create_permission: 'IC_ORDER_WRITE', bulk_permission: 'IC_ORDER_BULK_CREATE' }, { onCreateClick: props.toggleCreateOrderModal, onBulkClick: props.toggleBulkOrderModal, createText: <><span className="mr-2" dangerouslySetInnerHTML={{ __html: `&#8377;` }} /> New Order</>, bulkText: "Bulk Order" });

    
    const fetchMerchantInfo = () => {
        MerchantService.fetch().then((response) => {
            if (response.success) props.updateCurrentUser(response.data.merchant);
        });
    };

    const toggleSettlementModal = () => {
        setShowSettlementModal(!showSettlementModal);
    }

    const user_permissions = props.current_user.user?props.current_user.user.permissions:[] || [];

    const AccountBalanceComponent = (props) => {
        const balanceObj = getIndianRupeeNotation(props.current_user.scvab || 0, 3);
        return (
            <div className="d-flex justify-content-center flex-column" style={{ height: 55, lineHeight: "10px", marginTop: 10 }}>
                <div className="d-flex align-items-center justify-content-center">
                    <FAI icon={faWallet} size="1x" className="mr-2" />
                    <span className="font-weight-bold">Balance: &nbsp;₹ {user_permissions.includes('IC_BALANCE_READ')?`${balanceObj.integer}${balanceObj.decimal ? `.${balanceObj.decimal}` : ""}`: "****"} /-</span>
                    {/* <Icon type="info-circle" className="ml-2" /> */}
                </div>
                {!props.current_user.ecvabm ?
                    <div className="text-right mr-1">
                        <PermissableButton required_permission="IC_SETTLEMENT_INITIATE" type="link" className="pr-0" onClick={toggleSettlementModal}>Transfer to Bank</PermissableButton>
                    </div>
                    : null}
            </div>
        )
    }

    const componentTabList = [
        {
            key: 'balance',
            tab: <AccountBalanceComponent {...props} />,
        },
        user_permissions.includes("IC_CVA_READ") && {
            key: 'virtual_accounts',
            tab: (
                <div>
                    <Icon type="wallet" />
                    <span>Virtual Accounts</span>
                </div>
            ),
        },
        user_permissions.includes("IC_CVA_TRANSACTIONS_READ") && {
            key: 'transactions',
            tab: (
                <div>
                    <FAI icon={faRupeeSign} size="sm" className="mr-2" />
                    <span>Transactions</span>
                </div>
            ),
        },
        user_permissions.includes("IC_SETTLEMENT_REFUND_READ") && {
            key: 'disbursements',
            tab: (
                <div>
                    <Icon type="play-circle" />
                    <span>Settlements & Refunds</span>
                </div>
            ),
        },
        user_permissions.includes("IC_ORDER_READ") && props?.current_user?.enable_transaction_order  && {
            key: 'orders',
            tab: (
                <div>
                    <Icon type="container" />
                    <span>Orders</span>
                </div>
            ),
        },
        user_permissions.includes("IC_ACCOUNT_STATEMENT_READ") && {
            key: 'account_statement',
            tab: (
                <div>
                    <Icon type="file-done" />
                    <span>Account Statement</span>
                </div>
            ),
        },
    ]

    const components = {
        virtual_accounts: {
            route: "/insta-collect/virtual-accounts",
            component: <VirtualAccountsComponent {...props} actionRef={actionRef} setCurrentPage={setCurrentPage} />,
            extra: user_permissions.includes('IC_CVA_WRITE')?<Button className="mr-3 mt-3" ref={actionRef} type="primary"><Icon type="plus" /> New Virtual Account</Button>:null
        },
        disbursements: {
            route: "/insta-collect/outwards",
            component: <Disbursements {...props} bulkButtonRef={bulkButtonRef} actionRef={actionRef} />,
            extra: virtual_account_settings.enable_bulk_refund && <Button className="mr-3 mt-3" ref={actionRef} onClick={props.toggleBulkRefundModal}><Icon type="upload" /> Bulk Refunds</Button>
        },
        account_statement: {
            route: "/insta-collect/ledger",
            component: <Ledger {...props} />
        },
        transactions: {
            route: "/insta-collect/virtual-accounts/transactions",
            component: <VATransactions {...props} />,
            extra: user_permissions.includes('IC_CVA_TRANSACTION_LOOKUP')?<Button className="mr-3 mt-3" type='primary' ref={actionRef} icon='search'>Transaction Lookup</Button>:null
        },
        orders: {
            route: "/insta-collect/orders",
            component: <TransactionOrders bulkButtonRef={bulkButtonRef} actionRef={actionRef} />,
            // extra: <Button className="mr-3 mt-3" ref={actionRef} type="primary"><Icon type="plus" /> New Order</Button>
            extra: props.current_user.ebulk_order ? (
                <div className="mr-3" > <OrderPermissableButton /> </div>
            ) : <PermissableButton required_permission={"IC_ORDER_WRITE"} className="mr-3 mt-3" type='primary' onClick={props.toggleCreateOrderModal} icon='plus'>New Order</PermissableButton>

        },
    }

    const fetchSettlementAccounts = async () => {
        if (!props.current_user.key) return;
        const response = await SmartCollectDisbursements.account_list({});
        if (!response.success) {
            handleApiExceptions(response);
            return;
        }
        setSettlementAccounts(response.data);
    };

    const settleAmount = async (data) => {
        if (!props.current_user.key) return;
        setLoading(true);
        const response = await SmartCollectDisbursements.initiate_settlements(data);
        if (!response.success) {
            setLoading(false);
            handleApiExceptions(response);
            return;
        }
        toggleSettlementModal();
        fetchMerchantInfo();
        alertify("Success", `Payment settled successfully`, "success");
        setLoading(false);
    }

    const onTabRender = (key) => {
        setCurrentPage(key);
    }

    const renderChild = (ChildComponent, props) => {
        return <ChildComponent {...props} onTabRender={onTabRender} history={props.history} actionRef={actionRef} bulkButtonRef={bulkButtonRef} />
    }

    const getDefaultComponent = () => {
        if(user_permissions.includes('IC_CVA_READ'))
        return VirtualAccountsComponent;
        else if(user_permissions.includes('IC_CVA_TRANSACTIONS_READ'))
        return VATransactions;
        else if(user_permissions.includes('IC_SETTLEMENT_REFUND_READ'))
        return Disbursements;
        else if(user_permissions.includes('IC_ORDER_READ'))
        return TransactionOrders;
        else if(user_permissions.includes('IC_ACCOUNT_STATEMENT_READ'))
        return Ledger;
        else
        return VirtualAccountsComponent;
    }


    useEffect(() => {
        props.onChildMount();
        fetchSettlementAccounts();
    }, []);
    return (
        <>
        {props.current_user.esc?
        <ContentCard
            className="smart-collect-wrapper-card"
            tabList={componentTabList.filter(tab => tab)}
            activeTabKey={currentPage}
            onTabChange={(tabKey) => {
                if (tabKey !== "balance") {
                    setCurrentPage(tabKey);
                    props.history.push(components[tabKey].route)
                }
            }}
            tabExtra={(components[currentPage] || {}).extra}
        >
            <div className="p-3">
                <Switch>
                    <Route exact path="/smart-collect/virtual-accounts" render={(props) => renderChild(VirtualAccountsComponent, props)} pathkey="insta-collect" />
                    <Route exact path="/smart-collect/virtual-accounts/:id/transactions" render={(props) => renderChild(VATransactions, props)} pathkey="insta-collect" />
                    <Route exact path="/smart-collect/virtual-accounts/transactions" render={(props) => renderChild(VATransactions, props)} pathkey="insta-collect" />
                    <Route exact path="/smart-collect/outwards" render={(props) => renderChild(Disbursements, props)} pathkey="insta-collect" />
                    <Route exact path="/smart-collect/ledger" render={(props) => renderChild(Ledger, props)} pathkey="insta-collect" />
                    <Route exact path="/insta-collect/virtual-accounts" render={(props) => renderChild(VirtualAccountsComponent, props)} pathkey="insta-collect" />
                    {/* <Route exact path="/insta-collect/virtual-accounts/:id/transactions" render={(props) => renderChild(VATransactions, props)} pathkey="insta-collect" /> */}
                    <Route exact path="/insta-collect/virtual-accounts/transactions" render={(props) => renderChild(VATransactions, props)} pathkey="insta-collect" />
                    <Route exact path="/insta-collect/outwards" render={(props) => renderChild(Disbursements, props)} pathkey="insta-collect" />
                    <Route exact path="/insta-collect/ledger" render={(props) => renderChild(Ledger, props)} pathkey="insta-collect" />
                    <Route exact path="/insta-collect/orders" render={(props) => renderChild(TransactionOrders, props)} pathkey="insta-collect" />
                    <Route exact path="/insta-collect/:filter_by/:id/transactions" render={(props) => renderChild(VATransactions, props)} pathkey="insta-collect" />
                    <Route exact path="/insta-collect/:filter_by/:merchant_id/:id/transactions" render={(props) => renderChild(VATransactions, props)} pathkey="insta-collect" />
                    <Route exact path="*" render={(props) => renderChild(getDefaultComponent(), props)} pathkey="not-found" />
                </Switch>
            </div>

            <SettlementModal
                visible={showSettlementModal}
                toggleSettlementModal={toggleSettlementModal}
                settlementAccounts={settlementAccounts}
                settlement_payment_modes = {props.current_user.settlement_payment_modes}
                onSubmit={settleAmount}
                loading={loading}
                settlementEnabled={props.current_user.mse}
            />
        </ContentCard>
        :
        <Alert
          message="Error"
          description="You are not authorised to view this page."
          type="error"
          showIcon
        />
        }
        </>
    )
}

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user,
    showCreateOrderModal: state.uiReducer.showCreateOrderModal,
    showBulkOrderModal: state.uiReducer.showBulkOrderModal,
    showBulkRefundModal: state.uiReducer.showBulkRefundModal
})

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user)),
    toggleCreateOrderModal: () => dispatch(toggleCreateOrderModalAction()),
    toggleBulkOrderModal: () => dispatch(toggleBulkOrderModalAction()),
    toggleBulkRefundModal: () => dispatch(toggleBulkRefundModalAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(SmartCollect);